import React, { Component } from "react";
import { connect } from "react-redux";
import { Tab, Nav } from "react-bootstrap";
import requireAuth from "components/hoc/requireAuth";
import containsLongRunningProcess from "components/hoc/containsLongRunningProcess";
import RegisteredTrainings from "./RegisteredTrainings/RegisteredTrainings";
import AvailableTrainings from "./AvailableTrainings/AvailableTrainings";

class Index extends Component {
  state = {
    currentTab: "#tab1",
  };

  renderTabbedContent = () => {
    return (
      <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
        <Tab.Container
          id="nav-tab"
          defaultActiveKey="#tab1"
          activeKey={this.state.currentTab}
        >
          <nav className="scrollNav">
            <Nav variant="tabs" role="tablist">
              <Nav.Item>
                <Nav.Link
                  onClick={() => this.setState({ currentTab: "#tab1" })}
                  eventKey="#tab1"
                >
                  {/* <span className="icon-icon-menu-personal mr-1"></span> */}
                  Aldığım Eğitimler
                </Nav.Link>
              </Nav.Item>

              <Nav.Item>
                <Nav.Link
                  onClick={() => this.setState({ currentTab: "#tab2" })}
                  eventKey="#tab2"
                >
                  {/* <span className="icon-icon-menu-contact mr-1"></span> */}
                  Alabileceğim Eğitimler
                </Nav.Link>
              </Nav.Item>
            </Nav>
          </nav>

          <Tab.Content>
            <Tab.Pane eventKey="#tab1">
              <RegisteredTrainings />
            </Tab.Pane>
            <Tab.Pane eventKey="#tab2">
              <AvailableTrainings />
            </Tab.Pane>
          </Tab.Content>
        </Tab.Container>
      </div>
    );
  };

  render() {
    return (
      <section className="profilArea my-3">
        {this.props.spinner}
        <div className="container">
          <div className="row d-none d-sm-none d-md-flex d-lg-flex py-4 topRow align-items-center">
            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 px-4">
              <ul className="fgaBreadcrumb">
                <li>
                  <a href="/">
                    <span className="icon-home"></span>
                  </a>
                </li>
                <li className="active">Eğitimler</li>
              </ul>
            </div>
          </div>
          <div className="row d-flex d-sm-flex d-md-none d-lg-none py-4 topRow">
            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 px-4">
              <div className="profilBaslik">Eğitimler</div>
            </div>
          </div>
          <div className="row py-4 bottomRow">{this.renderTabbedContent()}</div>
        </div>
      </section>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    generalProfile: state.profile.general,
  };
};

export default connect(
  mapStateToProps,
  {}
)(requireAuth(containsLongRunningProcess(Index)));
